export function OutlineDanger({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 8.25V12.8333"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9995 19.6258H5.44453C2.2637 19.6258 0.934532 17.3525 2.47453 14.575L5.33453 9.42334L8.02953 4.58334C9.6612 1.64084 12.3379 1.64084 13.9695 4.58334L16.6645 9.43251L19.5245 14.5842C21.0645 17.3617 19.7262 19.635 16.5545 19.635H10.9995V19.6258Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9946 15.5835H11.0029"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
